import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Layout() {
    const [site, setSite] = useState(null);

    useEffect(() => {
        api.get("/site/content").then((r) => setSite(r.data)).catch(() => {});
    }, []);

    return (
        <>
            <Header />
            <main>
                <Outlet context={{ site }} />
            </main>
            <Footer />
            <WhatsAppButton number={site?.whatsapp || "355682116731"} />
        </>
    );
}
